
define('text!modules/reporting/campaigns/siteTransparency/templates/chart.html',[],function () { return '<div class="site-transparency-chart-container">\n  <div id="site-transparency-chart"></div>\n  <div class="no-data-chart-container">\n    {{>chartNoDataChart}}\n  </div>\n</div>\n';});

